import { render, staticRenderFns } from "./CrosswordClue.vue?vue&type=template&id=5f7f9014&"
import script from "./CrosswordClue.vue?vue&type=script&lang=js&"
export * from "./CrosswordClue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CrosswordClueLengthFilter: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/crossword/CrosswordClueLengthFilter.vue').default,CrosswordClueList: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/crossword/CrosswordClueList.vue').default,Advertisement: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Advertisement/Advertisement.vue').default,TheSidebar: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheSidebar.vue').default,ScrollTriggeredModal: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/crossword/ScrollTriggeredModal.vue').default})
